<template>
  <div>
    <!-- Alert -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar
      content-class="snackbar"
      :color="snackbar_background"
      right
      v-model="snackbar"
      :timeout="3000"
    >
      <v-icon :color="snackbar_icon_color" :size="64">{{ snackbar_icon }}</v-icon>
      <h2 :style="{ color: snackbar_text_color + '!important' }" class="ml-16">
        {{ snackbar_text }}
      </h2>

      <v-btn
        @click="snackbar = false"
        fab
        dark
        text
        small
        style="margin-top: -6rem; float: right !important; margin-right: -1rem !important"
      >
        <v-icon :color="snackbar_icon_color">mdi-window-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-card>
      <!-- MAIN TOOLBAR -->
      <v-toolbar dense class="indigo darken-1 headline" primary-title>
        <v-row justify="start">
          <v-col cols="5" align="left">
            <v-toolbar-title class="white--text"
              >Configurazione Part Program</v-toolbar-title
            >
          </v-col>
          <v-col cols="1">
            <Button
              colore_icona="primary"
              mdi_icona="mdi-plus"
              testo_tooltip="Aggiungi programma"
              v-on:buttonClick="addPartProgram"
            />
          </v-col>
          <v-col cols="1">
            <Button
              colore_icona="success"
              mdi_icona="mdi-floppy"
              testo_tooltip="Salva programmi"
              v-on:buttonClick="savePartPrograms"
            />
          </v-col>
        </v-row>
      </v-toolbar>

      <!-- PART PROGRAM LIST -->
      <v-container v-if="interfaces != null && configuration != null && programs != null">
        <v-expansion-panels>
          <v-expansion-panel v-for="(program, i) in programs" :key="i">
            <v-expansion-panel-header>
              <v-row no-gutters align="center">
                <v-col cols="11">
                  {{ program.name }}
                </v-col>
                <v-col cols="1">
                  <Button
                    colore_icona="error"
                    mdi_icona="mdi-delete"
                    testo_tooltip="Elimina programma"
                    v-on:buttonClick="deletePartProgram(program)"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row align="center">
                <v-col cols="6" align="center">
                  <v-text-field v-model="program.name" label="Nome programma" />
                </v-col>
                <v-col cols="4" align="center">
                  <v-text-field
                    type="number"
                    v-model="program.timeout"
                    label="Timeout esecuzione"
                  />
                </v-col>
              </v-row>
              <v-divider />
              <!-- STEPS -->
              <v-row align="center" class="my-3">
                <v-col cols="11" align="left">
                  <h2>Passaggi</h2>
                </v-col>
                <v-col cols="1" align="center">
                  <Button
                    colore_icona="primary"
                    mdi_icona="mdi-plus"
                    testo_tooltip="Nuovo passaggio"
                    v-on:buttonClick="addStep(program)"
                  />
                </v-col>
              </v-row>
              <v-expansion-panels>
                <v-expansion-panel v-for="(step, j) in program.steps" :key="j">
                  <v-expansion-panel-header>
                    <v-row no-gutters>
                      <v-col cols="11">
                        {{ step.name }}
                      </v-col>
                      <v-col cols="1">
                        <Button
                          colore_icona="error"
                          mdi_icona="mdi-delete"
                          testo_tooltip="Elimina passaggio"
                          v-on:buttonClick="deleteStep(step, program)"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <!-- STEP HEADING -->
                    <v-row align="center">
                      <v-col cols="3" align="center">
                        <v-text-field v-model="step.name" label="Nome passaggio" />
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-select
                          v-model="step.sequence_type"
                          label="Tipo Sequenza"
                          :items="configuration.sequence_types"
                        />
                      </v-col>
                      <v-col cols="3" align="center" v-if="step.sequence_type != 1">
                        <v-select
                          v-model="step.interface_id"
                          label="Interfaccia"
                          :items="interfaces"
                          item-text="interface_name"
                          item-value="interface_id"
                          @change="resetRegisterFields($event, step)"
                        />
                      </v-col>
                    </v-row>
                    <!-- STEP DETAIL -->
                    <v-row align="center" v-if="step.sequence_type == 1">
                      <v-col cols="3">
                        <v-text-field
                          type="number"
                          v-model="step.default_value"
                          label="Attesa (ms)"
                        />
                      </v-col>
                    </v-row>
                    <v-row align="center" v-if="step.sequence_type == 0">
                      <v-col cols="3">
                        <v-select
                          v-model="step.access_type"
                          label="Modalità accesso dato"
                          :items="access_types"
                          @change="step.default_value = null"
                        />
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-select
                          v-model="step.type"
                          label="Tipo dato"
                          :items="configuration.data_types"
                          @change="step.default_value = null"
                        />
                      </v-col>
                      <v-col
                        cols="3"
                        align="center"
                        v-if="step.type != null && step.access_type < 2"
                      >
                        <DynamicInputVue
                          v-model="step.default_value"
                          :items="configuration.data_types[step.type].values"
                          :type="configuration.data_types[step.type].type"
                          label="Valore Default"
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="
                        isNumber(step) && step.access_type > 0 && step.sequence_type == 0
                      "
                    >
                      <v-col cols="3">
                        <v-text-field
                          type="number"
                          v-model="step.boundaries.hard_min_value"
                          label="Limite minimo valore"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          type="number"
                          v-model="step.boundaries.hard_max_value"
                          label="Limite massimo valore"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          type="number"
                          v-model="step.boundaries.min_value"
                          label="Valore minimo default"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          type="number"
                          v-model="step.boundaries.max_value"
                          label="Valore massimo default"
                        />
                      </v-col>
                    </v-row>
                    <v-divider />
                    <!-- REGISTER DETAIL -->
                    <v-row class="my-3" v-if="step.sequence_type != 1">
                      <v-col cols="12" align="left">
                        <h2>Impostazioni registro</h2>
                      </v-col>
                    </v-row>
                    <v-row align="center" justify="start" v-if="step.sequence_type != 1">
                      <template v-for="(register, k, k1, k2) in getRegister(step)">
                        <v-col cols="3" :key="k" align="center">
                          <DynamicInputVue
                            v-model="step.register[register.field].value"
                            :items="register.values"
                            :type="register.type"
                            :label="register.name"
                          />
                        </v-col>
                        <v-col
                          cols="1"
                          :key="k1"
                          align="center"
                          v-if="
                            (register.type == 'string' || register.type == 'textarea') &&
                            step.sequence_type == 0
                          "
                        >
                          <Button
                            colore_icona="primary"
                            mdi_icona="mdi-format-list-text"
                            testo_tooltip="Parametri aggiuntivi"
                            v-on:buttonClick="
                              showParameters(step.register[register.field].parameters)
                            "
                          />
                        </v-col>
                        <v-col
                          cols="1"
                          v-if="
                            !(register.type == 'string' || register.type == 'textarea') &&
                            step.sequence_type == 0
                          "
                          :key="k2"
                        >
                          <v-icon disabled>mdi-format-list-text</v-icon>
                        </v-col>
                      </template>
                    </v-row>
                    <!-- FEEDBACK DETAIL -->
                    <v-row class="my-3" v-if="step.sequence_type == 2">
                      <v-col cols="12" align="left">
                        <h2>Valore Feedback</h2>
                      </v-col>
                    </v-row>
                    <v-row align="center" v-if="step.sequence_type == 2">
                      <v-col cols="2">
                        <v-text-field
                          type="number"
                          v-model="step.feedback.timeout"
                          label="Timeout esecuzione"
                        />
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          type="number"
                          v-model="step.feedback.polling_frequency"
                          label="Frequenza di controllo (ms)"
                        />
                      </v-col>
                      <v-col cols="2">
                        <v-checkbox
                          v-model="step.feedback.const"
                          label="Usa valore fisso"
                        />
                      </v-col>
                      <v-col cols="3" v-if="step.feedback.const != true">
                        <v-select
                          label="Valore step"
                          :items="getFeedbackSteps(step, program.steps)"
                          item-text="name"
                          item-value="id"
                          v-model="step.feedback.src"
                        />
                      </v-col>
                      <v-col cols="3" align="center" v-if="step.feedback.const == true">
                        <v-select
                          v-model="step.feedback.cast"
                          label="Tipo dato"
                          :items="configuration.data_types"
                          @change="step.feedback.src = null"
                        />
                      </v-col>
                      <v-col cols="3" v-if="step.feedback.const == true">
                        <DynamicInputVue
                          v-if="step.feedback.cast != null"
                          label="Valore"
                          :type="configuration.data_types[step.feedback.cast].type"
                          :items="configuration.data_types[step.feedback.cast].values"
                          v-model="step.feedback.src"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </v-card>
    <v-dialog v-model="ui.dialog.display" persistent>
      <v-toolbar dense color="indigo darken-1" dark>
        <v-row align="center" dark>
          <v-col cols="5" align="left">
            <v-toolbar-title>Parametri aggiuntivi</v-toolbar-title>
          </v-col>
          <v-col cols="2" align="center">
            <v-btn small light @click="addParameter()">
              <v-icon color="success">mdi-plus</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="5" align="right">
            <v-btn small light @click="ui.dialog.display = false">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-card
        v-if="ui.dialog.reference != null"
        style="max-height: 80vh; overflow-y: auto"
      >
        <v-container>
          <v-expansion-panels>
            <v-expansion-panel v-for="(parameter, i) in ui.dialog.reference" :key="i">
              <v-expansion-panel-header>
                <v-row no-gutters align="center" justify="start">
                  <v-col align="left" cols="11">
                    {{ parameter.name }}
                  </v-col>
                  <v-col cols="1">
                    <Button
                      colore_icona="error"
                      mdi_icona="mdi-delete"
                      testo_tooltip="Elimina parametro"
                      v-on:buttonClick="deleteParameter(parameter)"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row align="center">
                  <v-col cols="3">
                    <v-text-field label="Nome" v-model="parameter.name" />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field label="Simbolo" v-model="parameter.symbol" />
                  </v-col>
                </v-row>

                <v-row align="center">
                  <v-col cols="3">
                    <v-select
                      v-model="parameter.access_type"
                      label="Modalità accesso parametro"
                      :items="access_types"
                      @change="parameter.default_value = null"
                    />
                  </v-col>
                  <v-col cols="3" align="center">
                    <v-select
                      v-model="parameter.type"
                      label="Tipo parametro"
                      :items="configuration.data_types"
                      @change="parameter.default_value = null"
                    />
                  </v-col>
                  <v-col
                    cols="3"
                    align="center"
                    v-if="parameter.type != null && parameter.access_type < 2"
                  >
                    <DynamicInputVue
                      v-model="parameter.default_value"
                      :items="configuration.data_types[parameter.type].values"
                      :type="configuration.data_types[parameter.type].type"
                      label="Valore Default"
                    />
                  </v-col>
                </v-row>

                <v-row v-if="isNumber(parameter) && parameter.access_type > 0">
                  <v-col cols="3">
                    <v-text-field
                      type="number"
                      v-model="parameter.boundaries.hard_min_value"
                      label="Limite minimo valore"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      type="number"
                      v-model="parameter.boundaries.hard_max_value"
                      label="Limite massimo valore"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      type="number"
                      v-model="parameter.boundaries.min_value"
                      label="Valore minimo default"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      type="number"
                      v-model="parameter.boundaries.max_value"
                      label="Valore massimo default"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Button from "@/components/TOOLS/FormComponentPermissions/Button";
import DynamicInputVue from "./DynamicInput.vue";

export default {
  components: {
    Button,
    DynamicInputVue,
  },
  props: ["id_macchina"],
  data() {
    return {
      access_types: [
        { text: "Costante", value: 0 },
        { text: "Opzionale", value: 1 },
        { text: "Obbligatorio", value: 2 },
      ],
      configuration: null,
      interfaces: null,
      programs: null,

      overlay: false,
      // Snackbar
      snackbar: false,
      snackbar_background: "",
      snackbar_icon: "",
      snackbar_icon_color: "",
      snackbar_text: "",
      snackbar_text_color: "",
      ui: {
        dialog: {
          reference: null,
          display: false,
        },
        param_list_key: 0,
      },
    };
  },

  mounted() {
    this.getinterfacesList();
    this.getMacchineProgram();
    this.getSchema();
  },
  methods: {
    addPartProgram() {
      let id = 1;
      for (let i = 0; i < this.programs.length; i++) {
        id = Math.max(Number(this.programs[i].id), id) + 1;
      }
      this.programs.push({
        name: "Part program #" + id,
        id: id,
        steps: [],
        timeout: 15,
      });
    },
    deletePartProgram(program) {
      this.programs.splice(this.programs.indexOf(program), 1);
    },

    addStep(program) {
      let id = 1;
      for (let i = 0; i < program.steps.length; i++) {
        id = Math.max(Number(program.steps[i].id), id) + 1;
      }

      program.steps.push({
        name: "Passaggio #" + id,
        register: new Object(),
        access_type: 1,
        type: null,
        interface_id: null,
        id: id,
        default_value: null,
        sequence_type: null,
        feedback: {
          const: false,
          src: null,
          cast: null,
          timeout: 5,
          polling_frequency: 200,
        },
        boundaries: {
          min_value: null,
          max_value: null,
          hard_min_value: null,
          hard_max_value: null,
        },
      });
    },

    deleteStep(step, program) {
      program.steps.splice(program.steps.indexOf(step), 1);
    },

    deleteParameter(parameter) {
      const parameters = this.ui.dialog.reference;
      parameters.splice(parameters.indexOf(parameter), 1);
    },

    addParameter() {
      let id = 1;
      const parameters = this.ui.dialog.reference;
      for (let i = 0; i < parameters.length; i++) {
        id = Math.max(Number(parameters[i].id), id) + 1;
      }

      parameters.push({
        symbol: null,
        name: "Parametro #" + id,
        default_value: null,
        type: null,
        id: id,
        access_type: 1,
        boundaries: {
          min_value: null,
          max_value: null,
          hard_min_value: null,
          hard_max_value: null,
        },
      });
    },

    showParameters(params) {
      Object.assign(this.ui.dialog, { display: true, reference: params });
    },

    getFeedbackSteps(step, steps) {
      const result = new Array();
      for (let i = 0; i < steps.length; i++) {
        const step_i = steps[i];
        if (step_i == step) {
          break;
        }
        if (step_i.sequence_type == 0) {
          result.push(step_i);
        }
      }
      return result;
    },

    isNumber(item) {
      try {
        return this.configuration.data_types[item.type].type == "number";
      } catch {
        return false;
      }
    },
    getRegister(step) {
      try {
        for (let i = 0; i < this.interfaces.length; i++) {
          const interf = this.interfaces[i];
          if (interf.interface_id == step.interface_id) {
            return this.configuration.transport_layers[interf.transport_layer]
              .register_fields;
          }
        }
        return [];
      } catch {
        return [];
      }
    },
    resetRegisterFields(id, step) {
      const defaults = {
        boolean: false,
        number: 0,
        string: null,
        textarea: null,
        keyvalue: new Array(),
      };
      for (let i = 0; i < this.interfaces.length; i++) {
        const interf = this.interfaces[i];
        if (interf.interface_id == id) {
          step.register = new Object();
          const register_fields = this.configuration.transport_layers[
            interf.transport_layer
          ].register_fields;
          for (let j = 0; j < register_fields.length; j++) {
            const field = register_fields[j];
            step.register[field.field] = {
              value: defaults[field.type],
              parameters: new Array(),
            };
          }
        }
      }
    },

    // TO get the Json schema for part program intializer
    getSchema() {
      let finale = {
        controller: "quickconnext",
        method: "POST",
        richiesta: {
          action: "getpartprogramschema",
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("connext", finale).then((res) => {
        this.configuration = res.data;
      });
    },
    getMacchineProgram() {
      this.overlay = true;
      let setpp_detail = {
        controller: "quickconnext",
        method: "POST",
        richiesta: {
          action: "getmachineprograms",
          machine_id: this.id_macchina,
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("connext", setpp_detail).then((res) => {
        console.log(res.data);
        this.overlay = false;
        if (res.data == null || res.data == "") {
          this.programs = [];
        } else {
          this.programs = res.data;
        }
      });
    },
    getinterfacesList() {
      let setpp_detail = {
        controller: "quickconnext",
        method: "POST",
        richiesta: {
          action: "getmachineoutputinterfaces",
          machine_id: this.id_macchina,
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("connext", setpp_detail).then((res) => {
        this.interfaces = res.data;
      });
    },
    savePartPrograms() {
      this.overlay = true;
      const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(this.programs))));

      const request = {
        controller: "quickconnext",
        method: "PUT",
        richiesta: {
          action: "setmachineprograms",
          token: localStorage.getItem("user_token"),
          machine_id: this.id_macchina,
          part_prog_4_0: encoded,
        },
      };
      this.$store
        .dispatch("connext", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.snackbar = true;
            this.snackbar_background = "success";
            this.snackbar_icon = "mdi-check";
            this.snackbar_icon_color = "white";
            this.snackbar_text = "Part Program Salvato correttamente";
            this.snackbar_text_color = "white";
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.snackbar = true;
          this.snackbar_background = "warning";
          this.snackbar_icon = "mdi-alert";
          this.snackbar_icon_color = "white";
          this.snackbar_text = err;
          this.snackbar_text_color = "white";
        });
    },
  },
};
</script>
